var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.2178 5.5723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#4a0000;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{mix-blend-mode:screen;}.cls-7{fill:#4a0041;}.cls-8{fill:#4a0045;}.cls-9{fill:#4a0042;}.cls-10{fill:#4a0040;}.cls-11{fill:#4a0046;}.cls-12{fill:#4a0044;}.cls-13{fill:#4a003e;}.cls-14{fill:#4a004a;}.cls-15{fill:#4a0048;}.cls-16{fill:#4a003b;}.cls-17{fill:#4a004d;}.cls-18{fill:#4a0043;}.cls-19{fill:#4a003f;}.cls-20{fill:#4a0039;}.cls-21{fill:#4a0050;}.cls-22{fill:#4a004b;}.cls-23{fill:#4a003c;}.cls-24{fill:#4a0055;}.cls-25{fill:#4a0053;}.cls-26{fill:#4a003a;}.cls-27{fill:#4a0057;}.cls-28{fill:#4a005b;}.cls-29{fill:#4a005a;}.cls-30{fill:#4a0056;}.cls-31{fill:#4a004f;}.cls-32{fill:#4a005c;}.cls-33{fill:#4a0059;}.cls-34{fill:#4a0049;}.cls-35{fill:#4a005d;}.cls-36{fill:#4a0054;}.cls-37{fill:#4a004e;}.cls-38{fill:#4a0047;}.cls-39{fill:#4a0052;}.cls-40{fill:#4a0051;}.cls-41{fill:#4a003d;}.cls-42{fill:#4ad500;}.cls-43{fill:#4ace00;}.cls-44{fill:#4ad800;}.cls-45{fill:#4ac900;}.cls-46{fill:#4adc00;}.cls-47{fill:#4ada00;}.cls-48{fill:#4ac200;}.cls-49{fill:#4ac800;}.cls-50{fill:#4abe00;}.cls-51{fill:#4ac100;}.cls-52{fill:#4ad000;}.cls-53{fill:#4ad900;}.cls-54{fill:#4ab700;}.cls-55{fill:#4abc00;}.cls-56{fill:#4ac600;}.cls-57{fill:#4ad400;}.cls-58{fill:#4ab300;}.cls-59{fill:#4ab500;}.cls-60{fill:#4ad300;}.cls-61{fill:#4ad700;}.cls-62{fill:#4aad00;}.cls-63{fill:#4ab100;}.cls-64{fill:#4aa900;}.cls-65{fill:#4aab00;}.cls-66{fill:#4aaf00;}.cls-67{fill:#4ab200;}.cls-68{fill:#4acf00;}.cls-69{fill:#4aa600;}.cls-70{fill:#4aa700;}.cls-71{fill:#4aaa00;}.cls-72{fill:#4aae00;}.cls-73{fill:#4acd00;}.cls-74{fill:#4aa300;}.cls-75{fill:#4aa400;}.cls-76{fill:#4aa500;}.cls-77{fill:#4ac500;}.cls-78{fill:#4acc00;}.cls-79{fill:#4a9d00;}.cls-80{fill:#4aa100;}.cls-81{fill:#4ab400;}.cls-82{fill:#4a9a00;}.cls-83{fill:#4a9b00;}.cls-84{fill:#4aa000;}.cls-85{fill:#4a9500;}.cls-86{fill:#4a9800;}.cls-87{fill:#4a9400;}.cls-88{fill:#4a9700;}.cls-89{fill:#4a9200;}.cls-90{fill:#4a9300;}.cls-91{fill:#4a9100;}.cls-92{fill:#4a9600;}.cls-93{fill:#4a8d00;}.cls-94{fill:#4a8e00;}.cls-95{fill:#4a8f00;}.cls-96{fill:#4a8c00;}.cls-97{fill:#4a8a00;}.cls-98{fill:#4a8900;}.cls-99{fill:#4a8600;}.cls-100{fill:#4a8b00;}.cls-101{fill:#4a8400;}.cls-102{fill:#4a8500;}.cls-103{fill:#4a8700;}.cls-104{fill:#4a8800;}.cls-105{fill:#4a8300;}.cls-106{fill:#4a8200;}.cls-107{fill:#4a8100;}.cls-108{fill:#4a7d00;}.cls-109{fill:#4a8000;}.cls-110{fill:#4a7b00;}.cls-111{fill:#4a7800;}.cls-112{fill:#4a7e00;}.cls-113{fill:#4a7900;}.cls-114{fill:#4a7500;}.cls-115{fill:#4a7400;}.cls-116{fill:#4a7600;}.cls-117{fill:#4a6f00;}.cls-118{fill:#4a7300;}.cls-119{fill:#4a7100;}.cls-120{fill:#4a7200;}.cls-121{fill:red;}.cls-122{fill:#f90000;}.cls-123{fill:#f30000;}.cls-124{fill:#ed0000;}.cls-125{fill:#ec0000;}.cls-126{fill:#e70000;}.cls-127{fill:#fb0000;}.cls-128{fill:#e10000;}.cls-129{fill:#e60000;}.cls-130{fill:#f00000;}.cls-131{fill:#fe0000;}.cls-132{fill:#d00;}.cls-133{fill:#de0000;}.cls-134{fill:#e90000;}.cls-135{fill:#fc0000;}.cls-136{fill:#d90000;}.cls-137{fill:#da0000;}.cls-138{fill:#f10000;}.cls-139{fill:#d10000;}.cls-140{fill:#d70000;}.cls-141{fill:#db0000;}.cls-142{fill:#cf0000;}.cls-143{fill:#d00000;}.cls-144{fill:#d30000;}.cls-145{fill:#f60000;}.cls-146{fill:#cd0000;}.cls-147{fill:#d40000;}.cls-148{fill:#ef0000;}.cls-149{fill:#c80000;}.cls-150{fill:#c90000;}.cls-151{fill:#c00;}.cls-152{fill:#cb0000;}.cls-153{fill:#c50000;}.cls-154{fill:#c60000;}.cls-155{fill:#c10000;}.cls-156{fill:#c30000;}.cls-157{fill:#c40000;}.cls-158{fill:#bf0000;}.cls-159{fill:#bd0000;}.cls-160{fill:#b00;}.cls-161{fill:#bc0000;}.cls-162{fill:#b80000;}.cls-163{fill:#b70000;}.cls-164{fill:#b60000;}.cls-165{fill:#b90000;}.cls-166{fill:#b40000;}.cls-167{fill:#b30000;}.cls-168{fill:#b20000;}.cls-169{fill:#b00000;}.cls-170{fill:#ae0000;}.cls-171{fill:#b10000;}.cls-172{fill:#ad0000;}.cls-173{fill:#a00;}.cls-174{fill:#a90000;}.cls-175{fill:#a70000;}.cls-176{fill:#ac0000;}.cls-177{mix-blend-mode:soft-light;}.cls-178{fill:#4a0023;}.cls-179{fill:#4a0010;}.cls-180{fill:#4a0028;}.cls-181{fill:#4a0026;}.cls-182{fill:#4a000b;}.cls-183{fill:#4a0032;}.cls-184{fill:#4a000e;}.cls-185{fill:#4a001d;}.cls-186{fill:#4a0078;}.cls-187{fill:#4a002f;}.cls-188{fill:#4a0068;}.cls-189{fill:#4a0003;}.cls-190{fill:#4a009a;}.cls-191{fill:#4a007d;}.cls-192{fill:#4a0063;}.cls-193{fill:#4a0092;}.cls-194{fill:#4a00a6;}.cls-195{fill:#4a0084;}.cls-196{fill:#4a0074;}.cls-197{fill:#4a0017;}.cls-198{fill:#4a0088;}.cls-199{fill:#4a004c;}.cls-200{fill:#4a001c;}.cls-201{fill:#4a0007;}.cls-202{fill:#4a0066;}.cls-203{fill:#4a0030;}.cls-204{fill:#4a007e;}.cls-205{fill:#4a0013;}.cls-206{fill:#4a0098;}.cls-207{fill:#4a0069;}.cls-208{fill:#4a007f;}.cls-209{fill:#4a001b;}.cls-210{fill:#4a000d;}.cls-211{fill:#4a0036;}.cls-212{fill:#4a7c00;}.cls-213{fill:#4a5200;}.cls-214{fill:#4a4100;}.cls-215{fill:#4a3100;}.cls-216{fill:#4a9e00;}.cls-217{fill:#4a6900;}.cls-218{fill:#4a2100;}.cls-219{fill:#4a7f00;}.cls-220{fill:#4a1000;}.cls-221{fill:#4a6400;}.cls-222{fill:#4a4700;}.cls-223{fill:#4a6700;}.cls-224{fill:#4a3a00;}.cls-225{fill:#4ad100;}.cls-226{fill:#4a5c00;}.cls-227{fill:#4af300;}.cls-228{fill:#4ad600;}.cls-229{fill:#4aeb00;}.cls-230{fill:#4aff00;}.cls-231{fill:#4add00;}.cls-232{fill:#4a7000;}.cls-233{fill:#4a5500;}.cls-234{fill:#4a3900;}.cls-235{fill:#4a1e00;}.cls-236{fill:#4ae100;}.cls-237{fill:#4a4c00;}.cls-238{fill:#4a0f00;}.cls-239{fill:#4a6000;}.cls-240{fill:#4abf00;}.cls-241{fill:#4a5600;}.cls-242{fill:#4a3b00;}.cls-243{fill:#4a2c00;}.cls-244{fill:#4a9c00;}.cls-245{fill:#4a6c00;}.cls-246{fill:#4af100;}.cls-247{fill:#4a4900;}.cls-248{fill:#4a5700;}.cls-249{fill:#4a6600;}.cls-250{fill:#4a2b00;}.cls-251{fill:#e00;}.cls-252{fill:#9c0000;}.cls-253{fill:#8b0000;}.cls-254{fill:#7b0000;}.cls-255{fill:#e80000;}.cls-256{fill:#6b0000;}.cls-257{fill:#5a0000;}.cls-258{fill:#910000;}.cls-259{fill:#e00000;}.cls-260{fill:#d50000;}.cls-261{fill:#c00000;}.cls-262{fill:#f50000;}.cls-263{fill:#840000;}.cls-264{fill:#f80000;}.cls-265{fill:#e40000;}.cls-266{fill:#d20000;}.cls-267{fill:#a60000;}.cls-268{fill:#f40000;}.cls-269{fill:#eb0000;}.cls-270{fill:#ba0000;}.cls-271{fill:#9f0000;}.cls-272{fill:#830000;}.cls-273{fill:#680000;}.cls-274{fill:#960000;}.cls-275{fill:#590000;}.cls-276{fill:#a00000;}.cls-277{fill:#850000;}.cls-278{fill:#760000;}.cls-279{fill:#930000;}.cls-280{fill:#a10000;}.cls-281{fill:#df0000;}.cls-282{fill:#be0000;}.cls-283{fill:#750000;}.cls-284{fill:#fff;opacity:0.4;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.0009,
    y: 0.0011,
    width: 19.2178,
    height: 5.5722
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.5543,
    y: -14.3935,
    width: 20.3287,
    height: 20.3282
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.5543,
    y: -0.9931,
    width: 20.3287,
    height: 6.9278
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 19.2246,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(5.8118 13.8664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "17.861 -0.091 18.48 0.53 19.102 -0.091 18.48 -0.71 17.861 -0.091"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 18.6332,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2408 13.6431) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 19.2244,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.9866 14.2241) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 16.86,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(5.1306 12.2058) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 17.4496,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.8936 12.8056) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 18.0423,
    y: 0.654,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(4.6304 13.3768) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 18.6334,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4151 14.003) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 19.2243,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1403 14.558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 15.6764,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.7838 11.3688) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 16.267,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5466 11.9687) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 16.8598,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.3034 12.5628) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 17.4498,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.067 13.1648) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 18.0421,
    y: 1.8367,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7855 13.7108) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 18.633,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5593 14.3256) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 19.2243,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3041 14.904) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 14.4928,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4372 10.5318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 15.0857,
    y: 0.0631,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.1922 11.1244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 15.6762,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.956 11.725) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 16.2672,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7193 12.3272) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 16.8596,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4578 12.8987) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 17.4494,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2127 13.4887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 18.0421,
    y: 3.0203,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.9499 14.0561) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 18.633,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7224 14.6723) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 19.2246,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.4778 15.2633) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 13.3102,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.0908 9.6956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 13.9027,
    y: 0.0627,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(3.8529 10.2957) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 14.4926,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.6086 10.8874) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 15.0859,
    y: 1.2457,
    width: 0.877,
    height: 0.877,
    transform: "translate(3.3648 11.4815) rotate(-45.0509)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 15.676,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.111 12.0617) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 16.2668,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8663 12.6525) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 16.8596,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6209 13.2454) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 17.4494,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3757 13.8353) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 18.0424,
    y: 4.2022,
    width: 0.877,
    height: 0.877,
    transform: "translate(2.1236 14.414) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 18.633,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8862 15.0187) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 19.2243,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6337 15.5951) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 12.1285,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7447 8.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 12.7191,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5049 9.4574) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 13.31,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2616 10.0505) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 13.9029,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.0241 10.6527) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 14.4924,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7643 11.2247) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "14.904 2.866 15.524 3.487 16.145 2.866 15.524 2.245 14.904 2.866"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 15.676,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2741 12.4083) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 16.2668,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0294 12.9991) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "16.678 4.641 17.299 5.261 17.92 4.641 17.299 4.021 16.678 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 17.4494,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5395 14.1817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 18.0421,
    y: 5.3845,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2808 14.7459) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 10.9457,
    y: -0.5292,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.4015 8.0269) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 11.5358,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.1558 8.6179) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 12.1283,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9148 9.2142) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 12.7193,
    y: 1.2454,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.6755 9.8136) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 13.3098,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.418 10.3885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 13.9025,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1738 10.9806) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 14.4924,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.9274 11.5714) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "14.904 4.05 15.524 4.671 16.145 4.05 15.524 3.429 14.904 4.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "15.494 4.641 16.115 5.261 16.736 4.641 16.115 4.021 15.494 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 16.2668,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.1931 13.3455) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 16.8596,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9491 13.9379) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 9.7627,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(3.0517 7.1871) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 10.3537,
    y: 0.0632,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(2.8056 7.7776) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 10.9455,
    y: 0.6536,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.5706 8.3808) rotate(-45.0692)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 11.5359,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.3258 8.9731) rotate(-45.0739)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 12.1281,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0719 9.5529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 12.719,
    y: 2.4271,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8266 10.1428) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 13.3098,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.581 10.7352) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 13.9025,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3369 11.3273) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "14.311 4.641 14.932 5.261 15.553 4.641 14.932 4.021 14.311 4.641"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "14.904 5.233 15.524 5.854 16.145 5.233 15.524 4.611 14.904 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 15.676,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6023 13.1008) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 8.5794,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.7026 6.3478) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 9.1708,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4646 6.9474) rotate(-45.0421)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 9.7626,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(2.2205 7.54) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 10.3539,
    y: 1.2458,
    width: 0.8768,
    height: 0.8768,
    transform: "translate(1.9753 8.1317) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 10.9453,
    y: 1.8362,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(1.728 8.7205) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 11.5356,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.4785 9.3035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 12.1281,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.2349 9.8996) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 12.719,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9897 10.4894) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "13.128 4.641 13.749 5.261 14.37 4.641 13.749 4.021 13.128 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 13.9025,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.5007 11.6737) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 14.4924,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2557 12.2639) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 7.397,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.3588 5.5142) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 7.9881,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1129 6.1052) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 8.5792,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.871 6.6997) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 9.171,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.6328 7.3014) rotate(-45.093)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 9.7624,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.3789 7.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "10.172 2.866 10.792 3.487 11.412 2.866 10.792 2.245 10.172 2.866"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 10.9453,
    y: 3.0198,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.8908 9.0675) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 11.5356,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6418 9.6499) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "11.946 4.641 12.567 5.261 13.188 4.641 12.567 4.021 11.946 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 12.719,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1535 10.8357) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 13.3098,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.0907 11.4276) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 6.214,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0124 4.6779) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 6.8056,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.7705 5.2736) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 7.3968,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.5262 5.8657) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 7.9883,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.2811 6.4578) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 8.579,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.0304 7.04) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 9.1706,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.7879 7.6348) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 9.7624,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.542 8.2267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "10.172 4.05 10.792 4.671 11.412 4.05 10.792 3.429 10.172 4.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "10.763 4.641 11.385 5.261 12.006 4.641 11.385 4.021 10.763 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 11.5356,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1942 9.996) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 12.1281,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4368 10.592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 5.0315,
    y: -0.5288,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(1.6644 3.84) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 5.6224,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.4202 4.4326) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 6.2138,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1792 5.0288) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 6.8057,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.9373 5.6261) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 7.3967,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.686 6.2071) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 7.988,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4383 6.7919) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 8.579,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.1938 7.3864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 9.1706,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.049 7.9815) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 9.7627,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.2904 8.5812) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "10.172 5.233 10.792 5.854 11.412 5.233 10.792 4.611 10.172 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 10.9453,
    y: 5.384,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(-0.7816 9.7606) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 3.8484,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.3185 3.0041) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 4.4398,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0762 3.5993) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 5.0313,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8308 4.1898) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 5.6226,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.5869 4.7837) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 6.2136,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3396 5.3708) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 6.8054,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0951 5.9621) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 7.3967,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.151 6.5537) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 7.988,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.398 7.1378) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 8.5794,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.6389 7.7399) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9.1706,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8853 8.3278) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 9.7624,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1297 8.9191) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 2.666,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.9731 2.1689) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 3.2571,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7275 2.7602) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 3.8483,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.4842 3.3534) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 4.44,
    y: 1.2454,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.2415 3.9503) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 5.0312,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.0078 4.5322) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 5.6223,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.2533 5.1204) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 6.2136,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4974 5.7175) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 6.8054,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7419 6.3088) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 7.397,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.9847 6.9069) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 7.988,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.2336 7.4835) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 8.579,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4773 8.0782) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1.4829,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6267 1.3324) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 2.0741,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3823 1.9256) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 2.6658,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.1378 2.5177) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3.2573,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.1072 3.1098) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3.8481,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.3538 3.6965) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 4.4397,
    y: 2.4271,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.5979 4.2889) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 5.0312,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8444 4.8785) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 5.6223,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0896 5.4664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "6.032 4.641 6.653 5.261 7.274 4.641 6.653 4.021 6.032 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 6.8054,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5781 6.6552) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 7.3967,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.8227 7.2462) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 0.3003,
    y: -0.5288,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(0.2797 0.4956) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 0.891,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0352 1.0884) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1.4828,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2093 1.6806) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2.0743,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4539 2.2751) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2.6657,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6997 2.8618) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3.257,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9447 3.4492) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3.8481,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1905 4.0429) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 4.4397,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.4348 4.6355) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 5.0315,
    y: 4.2021,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(-1.6791 5.23) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 5.6223,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9251 5.8121) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 6.2136,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1691 6.41) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: -0.8827,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0662 -0.3403) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: -0.2911,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.3117 0.2518) rotate(-45.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 0.3001,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5562 0.8425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.8912,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8018 1.4372) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1.4826,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.0462 2.0254) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2.0739,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2907 2.6166) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2.6657,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5366 3.2084) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3.257,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.781 3.7952) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3.8484,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.0259 4.3938) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 4.4397,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.2709 4.9819) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 5.0312,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5154 5.5703) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: -0.8829,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9035 0.0065) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -0.2909,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.1494 0.5999) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 0.2999,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.3917 1.1872) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.8908,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6372 1.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1.4826,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8831 2.372) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2.0739,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1276 2.9632) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 2.666,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.373 3.5589) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 3.257,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.6165 4.1409) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 3.8481,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8617 4.7348) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -0.8831,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.739 0.3526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: -0.2913,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9835 0.944) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0.2999,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.228 1.5332) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 0.8908,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.4742 2.1267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1.483,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.7202 2.7219) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 2.0739,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.9639 3.3096) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 2.6657,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2083 3.9009) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: -0.8831,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.576 0.6993) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: -0.2913,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8204 1.2907) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 0.3003,
    y: 4.2021,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(-3.0651 1.8817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 0.8908,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.3104 2.473) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1.4826,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5549 3.0645) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "-1.065 4.641 -0.444 5.261 0.177 4.641 -0.444 4.021 -1.065 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: -0.2913,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.6566 1.637) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 0.2999,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.8984 2.2243) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: -0.8831,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-4.2477 1.3917) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 19.2246,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(5.8118 13.8664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "17.861 -0.091 18.48 0.53 19.102 -0.091 18.48 -0.71 17.861 -0.091"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 18.6332,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2408 13.6431) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 19.2244,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.9866 14.2241) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 16.86,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(5.1306 12.2058) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 17.4496,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.8936 12.8056) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 18.0423,
    y: 0.654,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(4.6304 13.3768) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 18.6334,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4151 14.003) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 19.2243,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1403 14.558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 15.6764,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.7838 11.3688) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 16.267,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5466 11.9687) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 16.8598,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.3034 12.5628) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 17.4498,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.067 13.1648) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 18.0421,
    y: 1.8367,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7855 13.7108) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 18.633,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5593 14.3256) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 19.2243,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3041 14.904) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 14.4928,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4372 10.5318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 15.0857,
    y: 0.0631,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.1922 11.1244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 15.6762,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.956 11.725) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 16.2672,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7193 12.3272) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 16.8596,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4578 12.8987) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 17.4494,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2127 13.4887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 18.0421,
    y: 3.0203,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.9499 14.0561) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 18.633,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7224 14.6723) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 19.2246,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.4778 15.2633) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 13.3102,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.0908 9.6956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 13.9027,
    y: 0.0627,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(3.8529 10.2957) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 14.4926,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.6086 10.8874) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 15.0859,
    y: 1.2457,
    width: 0.877,
    height: 0.877,
    transform: "translate(3.3648 11.4815) rotate(-45.0509)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 15.676,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.111 12.0617) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 16.2668,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8663 12.6525) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 16.8596,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6209 13.2454) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 17.4494,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3757 13.8353) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 18.0424,
    y: 4.2022,
    width: 0.877,
    height: 0.877,
    transform: "translate(2.1236 14.414) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 18.633,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8862 15.0187) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 19.2243,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6337 15.5951) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 12.1285,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7447 8.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 12.7191,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5049 9.4574) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 13.31,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2616 10.0505) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 13.9029,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.0241 10.6527) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 14.4924,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7643 11.2247) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "14.904 2.866 15.524 3.487 16.145 2.866 15.524 2.245 14.904 2.866"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 15.676,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2741 12.4083) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 16.2668,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0294 12.9991) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "16.678 4.641 17.299 5.261 17.92 4.641 17.299 4.021 16.678 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 17.4494,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5395 14.1817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 18.0421,
    y: 5.3845,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2808 14.7459) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 10.9457,
    y: -0.5292,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.4015 8.0269) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 11.5358,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.1558 8.6179) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 12.1283,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9148 9.2142) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 12.7193,
    y: 1.2454,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.6755 9.8136) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 13.3098,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.418 10.3885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 13.9025,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1738 10.9806) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 14.4924,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.9274 11.5714) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "14.904 4.05 15.524 4.671 16.145 4.05 15.524 3.429 14.904 4.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "15.494 4.641 16.115 5.261 16.736 4.641 16.115 4.021 15.494 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 16.2668,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.1931 13.3455) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 16.8596,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9491 13.9379) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 9.7627,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(3.0517 7.1871) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 10.3537,
    y: 0.0632,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(2.8056 7.7776) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 10.9455,
    y: 0.6536,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.5706 8.3808) rotate(-45.0692)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 11.5359,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.3258 8.9731) rotate(-45.0739)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 12.1281,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0719 9.5529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 12.719,
    y: 2.4271,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8266 10.1428) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 13.3098,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.581 10.7352) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 13.9025,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3369 11.3273) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "14.311 4.641 14.932 5.261 15.553 4.641 14.932 4.021 14.311 4.641"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "14.904 5.233 15.524 5.854 16.145 5.233 15.524 4.611 14.904 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 15.676,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6023 13.1008) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 8.5794,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.7026 6.3478) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 9.1708,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4646 6.9474) rotate(-45.0421)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 9.7626,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(2.2205 7.54) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 10.3539,
    y: 1.2458,
    width: 0.8768,
    height: 0.8768,
    transform: "translate(1.9753 8.1317) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 10.9453,
    y: 1.8362,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(1.728 8.7205) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 11.5356,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.4785 9.3035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 12.1281,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.2349 9.8996) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 12.719,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9897 10.4894) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "13.128 4.641 13.749 5.261 14.37 4.641 13.749 4.021 13.128 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 13.9025,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.5007 11.6737) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 14.4924,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2557 12.2639) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 7.397,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.3588 5.5142) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 7.9881,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1129 6.1052) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 8.5792,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.871 6.6997) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 9.171,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.6328 7.3014) rotate(-45.093)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 9.7624,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.3789 7.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "10.172 2.866 10.792 3.487 11.412 2.866 10.792 2.245 10.172 2.866"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 10.9453,
    y: 3.0198,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.8908 9.0675) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 11.5356,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6418 9.6499) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "11.946 4.641 12.567 5.261 13.188 4.641 12.567 4.021 11.946 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 12.719,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1535 10.8357) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 13.3098,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.0907 11.4276) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 6.214,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0124 4.6779) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 6.8056,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.7705 5.2736) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 7.3968,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.5262 5.8657) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 7.9883,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.2811 6.4578) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 8.579,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.0304 7.04) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 9.1706,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.7879 7.6348) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 9.7624,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.542 8.2267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "10.172 4.05 10.792 4.671 11.412 4.05 10.792 3.429 10.172 4.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "10.763 4.641 11.385 5.261 12.006 4.641 11.385 4.021 10.763 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 11.5356,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1942 9.996) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 12.1281,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4368 10.592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 5.0315,
    y: -0.5288,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(1.6644 3.84) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 5.6224,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.4202 4.4326) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 6.2138,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1792 5.0288) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 6.8057,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.9373 5.6261) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 7.3967,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.686 6.2071) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 7.988,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4383 6.7919) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 8.579,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.1938 7.3864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 9.1706,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.049 7.9815) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 9.7627,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.2904 8.5812) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "10.172 5.233 10.792 5.854 11.412 5.233 10.792 4.611 10.172 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 10.9453,
    y: 5.384,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(-0.7816 9.7606) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 3.8484,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.3185 3.0041) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 4.4398,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0762 3.5993) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 5.0313,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8308 4.1898) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 5.6226,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.5869 4.7837) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 6.2136,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3396 5.3708) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 6.8054,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0951 5.9621) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 7.3967,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.151 6.5537) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 7.988,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.398 7.1378) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 8.5794,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.6389 7.7399) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 9.1706,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8853 8.3278) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 9.7624,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1297 8.9191) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2.666,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.9731 2.1689) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 3.2571,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7275 2.7602) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 3.8483,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.4842 3.3534) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 4.44,
    y: 1.2454,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.2415 3.9503) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 5.0312,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.0078 4.5322) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 5.6223,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.2533 5.1204) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 6.2136,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4974 5.7175) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 6.8054,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7419 6.3088) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 7.397,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.9847 6.9069) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 7.988,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.2336 7.4835) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 8.579,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4773 8.0782) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1.4829,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6267 1.3324) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 2.0741,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3823 1.9256) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 2.6658,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.1378 2.5177) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3.2573,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.1072 3.1098) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 3.8481,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.3538 3.6965) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 4.4397,
    y: 2.4271,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.5979 4.2889) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 5.0312,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8444 4.8785) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 5.6223,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0896 5.4664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "6.032 4.641 6.653 5.261 7.274 4.641 6.653 4.021 6.032 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 6.8054,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5781 6.6552) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 7.3967,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.8227 7.2462) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 0.3003,
    y: -0.5288,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(0.2797 0.4956) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 0.891,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0352 1.0884) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1.4828,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2093 1.6806) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 2.0743,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4539 2.2751) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 2.6657,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6997 2.8618) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 3.257,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9447 3.4492) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 3.8481,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1905 4.0429) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 4.4397,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.4348 4.6355) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 5.0315,
    y: 4.2021,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(-1.6791 5.23) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 5.6223,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9251 5.8121) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 6.2136,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1691 6.41) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: -0.8827,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0662 -0.3403) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: -0.2911,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.3117 0.2518) rotate(-45.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 0.3001,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5562 0.8425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 0.8912,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8018 1.4372) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1.4826,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.0462 2.0254) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 2.0739,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2907 2.6166) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 2.6657,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5366 3.2084) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 3.257,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.781 3.7952) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 3.8484,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.0259 4.3938) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 4.4397,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.2709 4.9819) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 5.0312,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5154 5.5703) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: -0.8829,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9035 0.0065) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: -0.2909,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.1494 0.5999) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 0.2999,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.3917 1.1872) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 0.8908,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6372 1.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1.4826,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8831 2.372) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 2.0739,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1276 2.9632) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 2.666,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.373 3.5589) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 3.257,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.6165 4.1409) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 3.8481,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8617 4.7348) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: -0.8831,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.739 0.3526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: -0.2913,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9835 0.944) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 0.2999,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.228 1.5332) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 0.8908,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.4742 2.1267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 1.483,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.7202 2.7219) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 2.0739,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.9639 3.3096) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 2.6657,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2083 3.9009) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: -0.8831,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.576 0.6993) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: -0.2913,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8204 1.2907) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 0.3003,
    y: 4.2021,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(-3.0651 1.8817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 0.8908,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.3104 2.473) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 1.4826,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5549 3.0645) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "-1.065 4.641 -0.444 5.261 0.177 4.641 -0.444 4.021 -1.065 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: -0.2913,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.6566 1.637) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 0.2999,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.8984 2.2243) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: -0.8831,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-4.2477 1.3917) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 19.2246,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(5.8118 13.8664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "17.861 -0.091 18.48 0.53 19.102 -0.091 18.48 -0.71 17.861 -0.091"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 18.6332,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2408 13.6431) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 19.2244,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.9866 14.2241) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 16.86,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(5.1306 12.2058) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 17.4496,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.8936 12.8056) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 18.0423,
    y: 0.654,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(4.6304 13.3768) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.6334,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4151 14.003) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 19.2243,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1403 14.558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 15.6764,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.7838 11.3688) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 16.267,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5466 11.9687) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 16.8598,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.3034 12.5628) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 17.4498,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.067 13.1648) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.0421,
    y: 1.8367,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7855 13.7108) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.633,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5593 14.3256) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 19.2243,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3041 14.904) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 14.4928,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4372 10.5318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 15.0857,
    y: 0.0631,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.1922 11.1244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 15.6762,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.956 11.725) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 16.2672,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7193 12.3272) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 16.8596,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4578 12.8987) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 17.4494,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2127 13.4887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.0421,
    y: 3.0203,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.9499 14.0561) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.633,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7224 14.6723) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 19.2246,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.4778 15.2633) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 13.3102,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.0908 9.6956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 13.9027,
    y: 0.0627,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(3.8529 10.2957) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 14.4926,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.6086 10.8874) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 15.0859,
    y: 1.2457,
    width: 0.877,
    height: 0.877,
    transform: "translate(3.3648 11.4815) rotate(-45.0509)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 15.676,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.111 12.0617) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 16.2668,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8663 12.6525) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 16.8596,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6209 13.2454) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 17.4494,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3757 13.8353) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.0424,
    y: 4.2022,
    width: 0.877,
    height: 0.877,
    transform: "translate(2.1236 14.414) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.633,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8862 15.0187) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 19.2243,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6337 15.5951) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 12.1285,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7447 8.86) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 12.7191,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5049 9.4574) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 13.31,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2616 10.0505) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 13.9029,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.0241 10.6527) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 14.4924,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7643 11.2247) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "14.904 2.866 15.524 3.487 16.145 2.866 15.524 2.245 14.904 2.866"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 15.676,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2741 12.4083) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 16.2668,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0294 12.9991) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "16.678 4.641 17.299 5.261 17.92 4.641 17.299 4.021 16.678 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 17.4494,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5395 14.1817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 18.0421,
    y: 5.3845,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2808 14.7459) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 10.9457,
    y: -0.5292,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.4015 8.0269) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 11.5358,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.1558 8.6179) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 12.1283,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9148 9.2142) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 12.7193,
    y: 1.2454,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.6755 9.8136) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 13.3098,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.418 10.3885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 13.9025,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1738 10.9806) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 14.4924,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.9274 11.5714) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "14.904 4.05 15.524 4.671 16.145 4.05 15.524 3.429 14.904 4.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "15.494 4.641 16.115 5.261 16.736 4.641 16.115 4.021 15.494 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 16.2668,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.1931 13.3455) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 16.8596,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9491 13.9379) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 9.7627,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(3.0517 7.1871) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 10.3537,
    y: 0.0632,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(2.8056 7.7776) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 10.9455,
    y: 0.6536,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.5706 8.3808) rotate(-45.0692)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 11.5359,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.3258 8.9731) rotate(-45.0739)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 12.1281,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0719 9.5529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 12.719,
    y: 2.4271,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8266 10.1428) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 13.3098,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.581 10.7352) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 13.9025,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3369 11.3273) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "14.311 4.641 14.932 5.261 15.553 4.641 14.932 4.021 14.311 4.641"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "14.904 5.233 15.524 5.854 16.145 5.233 15.524 4.611 14.904 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 15.676,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6023 13.1008) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 8.5794,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.7026 6.3478) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 9.1708,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4646 6.9474) rotate(-45.0421)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 9.7626,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(2.2205 7.54) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 10.3539,
    y: 1.2458,
    width: 0.8768,
    height: 0.8768,
    transform: "translate(1.9753 8.1317) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 10.9453,
    y: 1.8362,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(1.728 8.7205) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 11.5356,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.4785 9.3035) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 12.1281,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.2349 9.8996) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 12.719,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9897 10.4894) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "13.128 4.641 13.749 5.261 14.37 4.641 13.749 4.021 13.128 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 13.9025,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.5007 11.6737) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 14.4924,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2557 12.2639) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 7.397,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.3588 5.5142) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 7.9881,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1129 6.1052) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 8.5792,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.871 6.6997) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 9.171,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.6328 7.3014) rotate(-45.093)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 9.7624,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.3789 7.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "10.172 2.866 10.792 3.487 11.412 2.866 10.792 2.245 10.172 2.866"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 10.9453,
    y: 3.0198,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.8908 9.0675) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 11.5356,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6418 9.6499) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "11.946 4.641 12.567 5.261 13.188 4.641 12.567 4.021 11.946 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 12.719,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1535 10.8357) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 13.3098,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.0907 11.4276) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 6.214,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0124 4.6779) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 6.8056,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.7705 5.2736) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 7.3968,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.5262 5.8657) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 7.9883,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.2811 6.4578) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 8.579,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.0304 7.04) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 9.1706,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.7879 7.6348) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 9.7624,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.542 8.2267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "10.172 4.05 10.792 4.671 11.412 4.05 10.792 3.429 10.172 4.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "10.763 4.641 11.385 5.261 12.006 4.641 11.385 4.021 10.763 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 11.5356,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1942 9.996) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 12.1281,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4368 10.592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 5.0315,
    y: -0.5288,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(1.6644 3.84) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 5.6224,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.4202 4.4326) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 6.2138,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1792 5.0288) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 6.8057,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.9373 5.6261) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 7.3967,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.686 6.2071) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 7.988,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4383 6.7919) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 8.579,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.1938 7.3864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 9.1706,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.049 7.9815) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 9.7627,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.2904 8.5812) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "10.172 5.233 10.792 5.854 11.412 5.233 10.792 4.611 10.172 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 10.9453,
    y: 5.384,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(-0.7816 9.7606) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 3.8484,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.3185 3.0041) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 4.4398,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0762 3.5993) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 5.0313,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8308 4.1898) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 5.6226,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.5869 4.7837) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 6.2136,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3396 5.3708) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 6.8054,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0951 5.9621) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 7.3967,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.151 6.5537) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 7.988,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.398 7.1378) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 8.5794,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.6389 7.7399) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 9.1706,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8853 8.3278) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 9.7624,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1297 8.9191) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2.666,
    y: -0.5289,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.9731 2.1689) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 3.2571,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7275 2.7602) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 3.8483,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.4842 3.3534) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 4.44,
    y: 1.2454,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(0.2415 3.9503) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 5.0312,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.0078 4.5322) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 5.6223,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.2533 5.1204) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 6.2136,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4974 5.7175) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 6.8054,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7419 6.3088) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 7.397,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.9847 6.9069) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 7.988,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.2336 7.4835) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 8.579,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4773 8.0782) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 1.4829,
    y: -0.529,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6267 1.3324) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 2.0741,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3823 1.9256) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 2.6658,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.1378 2.5177) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 3.2573,
    y: 1.2455,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.1072 3.1098) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 3.8481,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.3538 3.6965) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 4.4397,
    y: 2.4271,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.5979 4.2889) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 5.0312,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8444 4.8785) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 5.6223,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0896 5.4664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "6.032 4.641 6.653 5.261 7.274 4.641 6.653 4.021 6.032 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 6.8054,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5781 6.6552) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 7.3967,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.8227 7.2462) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 0.3003,
    y: -0.5288,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(0.2797 0.4956) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 0.891,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0352 1.0884) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 1.4828,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2093 1.6806) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 2.0743,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4539 2.2751) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 2.6657,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6997 2.8618) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 3.257,
    y: 2.4273,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9447 3.4492) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 3.8481,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1905 4.0429) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 4.4397,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.4348 4.6355) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 5.0315,
    y: 4.2021,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(-1.6791 5.23) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 5.6223,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9251 5.8121) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 6.2136,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1691 6.41) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: -0.8827,
    y: -0.5291,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0662 -0.3403) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: -0.2911,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.3117 0.2518) rotate(-45.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 0.3001,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5562 0.8425) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 0.8912,
    y: 1.2454,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8018 1.4372) rotate(-45.0924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 1.4826,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.0462 2.0254) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 2.0739,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2907 2.6166) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 2.6657,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5366 3.2084) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3.257,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.781 3.7952) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 3.8484,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.0259 4.3938) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 4.4397,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.2709 4.9819) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 5.0312,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5154 5.5703) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: -0.8829,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9035 0.0065) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: -0.2909,
    y: 1.2455,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.1494 0.5999) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 0.2999,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.3917 1.1872) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 0.8908,
    y: 2.4271,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.6372 1.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 1.4826,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8831 2.372) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 2.0739,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1276 2.9632) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 2.666,
    y: 4.202,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.373 3.5589) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 3.257,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.6165 4.1409) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 3.8481,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8617 4.7348) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: -0.8831,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.739 0.3526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: -0.2913,
    y: 2.4272,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.9835 0.944) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 0.2999,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.228 1.5332) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 0.8908,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.4742 2.1267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 1.483,
    y: 4.202,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.7202 2.7219) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2.0739,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.9639 3.3096) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2.6657,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2083 3.9009) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: -0.8831,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.576 0.6993) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: -0.2913,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8204 1.2907) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 0.3003,
    y: 4.2021,
    width: 0.8771,
    height: 0.8771,
    transform: "translate(-3.0651 1.8817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 0.8908,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.3104 2.473) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 1.4826,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5549 3.0645) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "-1.065 4.641 -0.444 5.261 0.177 4.641 -0.444 4.021 -1.065 4.641"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: -0.2913,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.6566 1.637) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 0.2999,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.8984 2.2243) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: -0.8831,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-4.2477 1.3917) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 19.2246,
    y: -0.5279,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(5.8325 13.8879) rotate(-45.0416)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "17.861 -0.089 18.48 0.53 19.102 -0.089 18.48 -0.71 17.861 -0.089"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 18.6332,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2408 13.6431) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 19.2244,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.9866 14.2241) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.86,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(5.1488 12.2247) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.4496,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.8936 12.8056) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.0423,
    y: 0.654,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(4.6304 13.3768) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 18.633,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.3959 13.9807) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 19.2243,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1403 14.558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 15.6764,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.8007 11.3864) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.267,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5466 11.9687) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.8598,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.3034 12.5628) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.4494,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.0491 13.1437) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.0421,
    y: 1.8367,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7855 13.7108) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 18.6334,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.559 14.3258) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 19.2243,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3041 14.904) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 14.4928,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4528 10.5482) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 15.0857,
    y: 0.0631,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.1922 11.1244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.6762,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.956 11.725) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.2668,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7027 12.3074) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.8596,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4578 12.8987) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.4498,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2123 13.4888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.0421,
    y: 3.0203,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.9499 14.0561) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 18.633,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7224 14.6723) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.2243,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4685 15.2497) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 13.3106,
    y: -0.528,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.098 9.7037) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 13.9027,
    y: 0.0627,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(3.8529 10.2957) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 14.4926,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.6086 10.8874) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "14.904 1.685 15.524 2.306 16.145 1.685 15.524 1.064 14.904 1.685"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.676,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.111 12.0617) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.2672,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.8659 12.6526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.8596,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6209 13.2454) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 17.4494,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3757 13.8353) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 18.0421,
    y: 4.2029,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.115 14.4011) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.633,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8862 15.0187) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.2243,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6337 15.5951) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 12.1285,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7577 8.8738) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 12.7191,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5049 9.4574) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 13.3104,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2551 10.0429) rotate(-45.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 13.9025,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.0101 10.6355) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 14.4924,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7643 11.2247) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.0859,
    y: 2.4283,
    width: 0.877,
    height: 0.877,
    transform: "translate(2.5134 11.8076) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 15.676,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2741 12.4083) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 16.2668,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0294 12.9991) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 16.8596,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7846 13.5918) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 17.4494,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5395 14.1817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 18.0421,
    y: 5.3845,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2808 14.7459) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.9457,
    y: -0.5282,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.4133 8.0394) rotate(-45.1108)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 11.5358,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.1558 8.6179) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 12.1283,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9148 9.2142) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 12.719,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.6627 9.7976) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 13.3102,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4121 10.3803) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 13.9029,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1735 10.9808) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 14.4924,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.9274 11.5714) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "14.904 4.05 15.524 4.671 16.145 4.05 15.524 3.429 14.904 4.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 15.676,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4379 12.7547) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 16.2668,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.1931 13.3455) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 16.8596,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9491 13.9379) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 9.7627,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(3.0622 7.1983) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.354,
    y: 0.0632,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(2.8086 7.781) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.9455,
    y: 0.6536,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.5706 8.3808) rotate(-45.0692)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 11.5356,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.3143 8.9585) rotate(-44.9862)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 12.1281,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0719 9.5529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 12.7193,
    y: 2.428,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.8262 10.143) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 13.3102,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5758 10.7264) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 13.9025,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3369 11.3273) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 14.4924,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0912 11.9178) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "14.904 5.233 15.524 5.854 16.145 5.233 15.524 4.611 14.904 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 15.676,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6023 13.1008) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 8.5794,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.7118 6.3578) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 9.1708,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4646 6.9474) rotate(-45.0421)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 9.7626,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(2.2205 7.54) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.3538,
    y: 1.2459,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.9677 8.1221) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 10.9453,
    y: 1.8362,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(1.728 8.7205) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 11.5359,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.4781 9.3037) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 12.1281,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.2349 9.8996) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 12.719,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9897 10.4894) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 13.3102,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7401 11.0721) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 13.9025,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.5007 11.6737) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 14.4924,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2557 12.2639) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 7.3971,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3667 5.523) rotate(-45.0872)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 7.9881,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1129 6.1052) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 8.5792,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.871 6.6997) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 9.1707,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.6239 7.2893) rotate(-45.0052)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 9.7624,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.3789 7.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 10.3542,
    y: 2.4284,
    width: 0.8768,
    height: 0.8768,
    transform: "translate(1.1317 8.4673) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 10.9453,
    y: 3.0198,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.8908 9.0675) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 11.5356,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6418 9.6499) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 12.1281,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3987 10.246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 12.719,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1535 10.8357) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 13.3102,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0948 11.4176) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 6.214,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0191 4.6853) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 6.8056,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.7705 5.2736) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.3969,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5263 5.8659) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.988,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2735 6.447) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.579,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.0304 7.04) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9.171,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7876 7.6349) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 9.7624,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.542 8.2267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 10.3538,
    y: 3.6111,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.2954 8.8135) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 10.9453,
    y: 4.2024,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.0542 9.4142) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 11.5356,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1942 9.996) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 12.1281,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4368 10.592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 5.0315,
    y: -0.5279,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(1.6697 3.8461) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 5.6224,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.4202 4.4326) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 6.2138,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1792 5.0288) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 6.8054,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9309 5.6166) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.3967,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.686 6.2072) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.9883,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.4379 6.792) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.579,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.1938 7.3864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9.1706,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.049 7.9815) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 9.7624,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2942 8.5731) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 10.3538,
    y: 4.7937,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5404 9.1595) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 10.9453,
    y: 5.384,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(-0.7816 9.7606) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 3.8484,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.3226 3.0089) rotate(-45.0693)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 4.4398,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0762 3.5993) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 5.0313,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8308 4.1898) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 5.6223,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5818 4.7754) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 6.2136,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3396 5.3708) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 6.8057,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.0947 5.9623) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.3967,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1509 6.5539) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.988,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.398 7.1378) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 8.579,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.6421 7.7324) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.1706,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8853 8.3278) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 9.7624,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1297 8.9191) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.666,
    y: -0.5279,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.9759 2.1724) rotate(-45.0872)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 3.2571,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7275 2.7602) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 3.8483,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.4842 3.3534) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 4.4397,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.2377 3.9433) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 5.0312,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.0078 4.5322) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 5.6226,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.2536 5.1205) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 6.2136,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4974 5.7175) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.8054,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7419 6.3088) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 7.3967,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9871 6.9003) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 7.988,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.2336 7.4835) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 8.579,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4773 8.0782) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 1.4829,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6282 1.3347) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.0741,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3823 1.9256) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2.6658,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.1378 2.5177) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 3.257,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.1098 3.1041) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 3.8481,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.3538 3.6965) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 4.44,
    y: 2.428,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-0.5983 4.2891) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 5.0312,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8444 4.8785) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.6223,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0896 5.4664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.2136,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.3336 6.0639) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 6.8054,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5781 6.6552) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 7.3967,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.8226 7.2463) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 0.3005,
    y: -0.5279,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(0.2803 0.497) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 0.891,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0352 1.0884) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 1.4828,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2093 1.6806) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2.0739,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4551 2.2707) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2.6657,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6997 2.8618) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 3.2573,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.9451 3.4494) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 3.8481,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1905 4.0429) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.4397,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.4348 4.6355) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.0312,
    y: 4.2028,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.6803 5.2246) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.6223,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9251 5.8121) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 6.2136,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1691 6.41) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: -0.8827,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0673 -0.3406) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -0.2911,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.3117 0.2518) rotate(-45.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 0.3003,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5562 0.8432) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 0.8908,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.8017 1.4341) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 1.4826,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.0462 2.0254) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2.0743,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2911 2.6167) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2.6657,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5366 3.2084) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 3.257,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.781 3.7952) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 3.8481,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.0264 4.389) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.4397,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.2709 4.9819) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 5.0312,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5154 5.5703) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: -0.8829,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9035 0.0065) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.2913,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.148 0.598) rotate(-45.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.3002,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.3921 1.1882) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.8912,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6376 1.7801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 1.4826,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8831 2.372) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2.0739,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1276 2.9632) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2.6657,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.3728 3.5548) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 3.257,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.6165 4.1409) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 3.8481,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8617 4.7348) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: -0.8831,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.739 0.3526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.2909,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.9838 0.9441) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.3002,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.2287 1.5346) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.8908,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.4742 2.1267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 1.4826,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.7193 2.7184) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2.0739,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.9639 3.3096) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2.6657,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2083 3.9009) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: -0.8831,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.576 0.6993) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.2913,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8204 1.2907) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.3002,
    y: 4.2028,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.0646 1.8806) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.8908,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.3104 2.473) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 1.4826,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5549 3.0645) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: -0.8831,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.4122 1.0456) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: -0.2913,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.6566 1.637) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.3002,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.8998 2.2264) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: -0.8831,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-4.2477 1.3917) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 19.2246,
    y: -0.5279,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(5.8325 13.8879) rotate(-45.0416)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "17.861 -0.089 18.48 0.53 19.102 -0.089 18.48 -0.71 17.861 -0.089"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 18.6332,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2408 13.6431) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 19.2244,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.9866 14.2241) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 16.86,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(5.1488 12.2247) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 17.4496,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.8936 12.8056) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 18.0423,
    y: 0.654,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(4.6304 13.3768) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 18.633,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.3959 13.9807) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 19.2243,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1403 14.558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 15.6764,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.8007 11.3864) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 16.267,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5466 11.9687) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 16.8598,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.3034 12.5628) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 17.4494,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.0491 13.1437) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 18.0421,
    y: 1.8367,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7855 13.7108) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 18.6334,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.559 14.3258) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 19.2243,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3041 14.904) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 14.4928,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4528 10.5482) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 15.0857,
    y: 0.0631,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.1922 11.1244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 15.6762,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.956 11.725) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 16.2668,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7027 12.3074) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 16.8596,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4578 12.8987) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 17.4498,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2123 13.4888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 18.0421,
    y: 3.0203,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.9499 14.0561) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 18.633,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7224 14.6723) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 19.2243,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4685 15.2497) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 13.3106,
    y: -0.528,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.098 9.7037) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 13.9027,
    y: 0.0627,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(3.8529 10.2957) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 14.4926,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.6086 10.8874) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "14.904 1.685 15.524 2.306 16.145 1.685 15.524 1.064 14.904 1.685"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 15.676,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.111 12.0617) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 16.2672,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.8659 12.6526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 16.8596,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6209 13.2454) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 17.4494,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3757 13.8353) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 18.0421,
    y: 4.2029,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.115 14.4011) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 18.633,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8862 15.0187) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 19.2243,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6337 15.5951) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 12.1285,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7577 8.8738) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 12.7191,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5049 9.4574) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 13.3104,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2551 10.0429) rotate(-45.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 13.9025,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.0101 10.6355) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 14.4924,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7643 11.2247) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 15.0859,
    y: 2.4283,
    width: 0.877,
    height: 0.877,
    transform: "translate(2.5134 11.8076) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 15.676,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2741 12.4083) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 16.2668,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0294 12.9991) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 16.8596,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7846 13.5918) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 17.4494,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5395 14.1817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 18.0421,
    y: 5.3845,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2808 14.7459) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 10.9457,
    y: -0.5282,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.4133 8.0394) rotate(-45.1108)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 11.5358,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.1558 8.6179) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 12.1283,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9148 9.2142) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 12.719,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.6627 9.7976) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 13.3102,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4121 10.3803) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 13.9029,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1735 10.9808) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 14.4924,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.9274 11.5714) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "14.904 4.05 15.524 4.671 16.145 4.05 15.524 3.429 14.904 4.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 15.676,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4379 12.7547) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 16.2668,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.1931 13.3455) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 16.8596,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9491 13.9379) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 9.7627,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(3.0622 7.1983) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 10.354,
    y: 0.0632,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(2.8086 7.781) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 10.9455,
    y: 0.6536,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.5706 8.3808) rotate(-45.0692)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 11.5356,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.3143 8.9585) rotate(-44.9862)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 12.1281,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0719 9.5529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 12.7193,
    y: 2.428,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.8262 10.143) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 13.3102,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5758 10.7264) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 13.9025,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3369 11.3273) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 14.4924,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0912 11.9178) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "14.904 5.233 15.524 5.854 16.145 5.233 15.524 4.611 14.904 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 15.676,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6023 13.1008) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 8.5794,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.7118 6.3578) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 9.1708,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4646 6.9474) rotate(-45.0421)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 9.7626,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(2.2205 7.54) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 10.3538,
    y: 1.2459,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.9677 8.1221) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 10.9453,
    y: 1.8362,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(1.728 8.7205) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 11.5359,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.4781 9.3037) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 12.1281,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.2349 9.8996) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 12.719,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9897 10.4894) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 13.3102,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7401 11.0721) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 13.9025,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.5007 11.6737) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 14.4924,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2557 12.2639) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 7.3971,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3667 5.523) rotate(-45.0872)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 7.9881,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1129 6.1052) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 8.5792,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.871 6.6997) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 9.1707,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.6239 7.2893) rotate(-45.0052)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 9.7624,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.3789 7.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 10.3542,
    y: 2.4284,
    width: 0.8768,
    height: 0.8768,
    transform: "translate(1.1317 8.4673) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 10.9453,
    y: 3.0198,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.8908 9.0675) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 11.5356,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6418 9.6499) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 12.1281,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3987 10.246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 12.719,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1535 10.8357) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 13.3102,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0948 11.4176) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 6.214,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0191 4.6853) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 6.8056,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.7705 5.2736) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 7.3969,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5263 5.8659) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 7.988,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2735 6.447) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 8.579,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.0304 7.04) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 9.171,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7876 7.6349) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 9.7624,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.542 8.2267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 10.3538,
    y: 3.6111,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.2954 8.8135) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 10.9453,
    y: 4.2024,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.0542 9.4142) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 11.5356,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1942 9.996) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 12.1281,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4368 10.592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 5.0315,
    y: -0.5279,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(1.6697 3.8461) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 5.6224,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.4202 4.4326) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 6.2138,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1792 5.0288) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 6.8054,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9309 5.6166) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 7.3967,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.686 6.2072) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 7.9883,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.4379 6.792) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 8.579,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.1938 7.3864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 9.1706,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.049 7.9815) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 9.7624,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2942 8.5731) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 10.3538,
    y: 4.7937,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5404 9.1595) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 10.9453,
    y: 5.384,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(-0.7816 9.7606) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3.8484,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.3226 3.0089) rotate(-45.0693)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 4.4398,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0762 3.5993) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 5.0313,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8308 4.1898) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 5.6223,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5818 4.7754) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 6.2136,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3396 5.3708) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 6.8057,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.0947 5.9623) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 7.3967,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1509 6.5539) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 7.988,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.398 7.1378) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 8.579,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.6421 7.7324) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 9.1706,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8853 8.3278) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 9.7624,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1297 8.9191) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 2.666,
    y: -0.5279,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.9759 2.1724) rotate(-45.0872)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 3.2571,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7275 2.7602) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3.8483,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.4842 3.3534) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 4.4397,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.2377 3.9433) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 5.0312,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.0078 4.5322) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 5.6226,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.2536 5.1205) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 6.2136,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4974 5.7175) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 6.8054,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7419 6.3088) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 7.3967,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9871 6.9003) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 7.988,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.2336 7.4835) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 8.579,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4773 8.0782) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 1.4829,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6282 1.3347) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 2.0741,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3823 1.9256) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 2.6658,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.1378 2.5177) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 3.257,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.1098 3.1041) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3.8481,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.3538 3.6965) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 4.44,
    y: 2.428,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-0.5983 4.2891) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 5.0312,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8444 4.8785) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 5.6223,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0896 5.4664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 6.2136,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.3336 6.0639) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 6.8054,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5781 6.6552) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 7.3967,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.8226 7.2463) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 0.3005,
    y: -0.5279,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(0.2803 0.497) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 0.891,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0352 1.0884) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 1.4828,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2093 1.6806) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 2.0739,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4551 2.2707) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 2.6657,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6997 2.8618) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 3.2573,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.9451 3.4494) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3.8481,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1905 4.0429) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 4.4397,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.4348 4.6355) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 5.0312,
    y: 4.2028,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.6803 5.2246) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 5.6223,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9251 5.8121) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 6.2136,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1691 6.41) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: -0.8827,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0673 -0.3406) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: -0.2911,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.3117 0.2518) rotate(-45.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 0.3003,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5562 0.8432) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 0.8908,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.8017 1.4341) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 1.4826,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.0462 2.0254) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 2.0743,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2911 2.6167) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 2.6657,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5366 3.2084) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 3.257,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.781 3.7952) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 3.8481,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.0264 4.389) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 4.4397,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.2709 4.9819) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 5.0312,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5154 5.5703) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: -0.8829,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9035 0.0065) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: -0.2913,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.148 0.598) rotate(-45.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 0.3002,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.3921 1.1882) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 0.8912,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6376 1.7801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 1.4826,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8831 2.372) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 2.0739,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1276 2.9632) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 2.6657,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.3728 3.5548) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 3.257,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.6165 4.1409) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 3.8481,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8617 4.7348) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: -0.8831,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.739 0.3526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: -0.2909,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.9838 0.9441) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 0.3002,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.2287 1.5346) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 0.8908,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.4742 2.1267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1.4826,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.7193 2.7184) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 2.0739,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.9639 3.3096) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 2.6657,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2083 3.9009) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: -0.8831,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.576 0.6993) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: -0.2913,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8204 1.2907) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 0.3002,
    y: 4.2028,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.0646 1.8806) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 0.8908,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.3104 2.473) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1.4826,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5549 3.0645) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: -0.8831,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.4122 1.0456) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: -0.2913,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.6566 1.637) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 0.3002,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.8998 2.2264) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: -0.8831,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-4.2477 1.3917) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 19.2246,
    y: -0.5279,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(5.8325 13.8879) rotate(-45.0416)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "17.861 -0.089 18.48 0.53 19.102 -0.089 18.48 -0.71 17.861 -0.089"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 18.6332,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2408 13.6431) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 19.2244,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.9866 14.2241) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 16.86,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(5.1488 12.2247) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 17.4496,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.8936 12.8056) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 18.0423,
    y: 0.654,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(4.6304 13.3768) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 18.633,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.3959 13.9807) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-255",
    x: 19.2243,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1403 14.558) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 15.6764,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.8007 11.3864) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 16.267,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5466 11.9687) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 16.8598,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.3034 12.5628) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 17.4494,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.0491 13.1437) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 18.0421,
    y: 1.8367,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7855 13.7108) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 18.6334,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.559 14.3258) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 19.2243,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3041 14.904) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 14.4928,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.4528 10.5482) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 15.0857,
    y: 0.0631,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.1922 11.1244) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 15.6762,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.956 11.725) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 16.2668,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.7027 12.3074) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 16.8596,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4578 12.8987) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 17.4498,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2123 13.4888) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 18.0421,
    y: 3.0203,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.9499 14.0561) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 18.633,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7224 14.6723) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 19.2243,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4685 15.2497) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 13.3106,
    y: -0.528,
    width: 0.8774,
    height: 0.8774,
    transform: "translate(4.098 9.7037) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 13.9027,
    y: 0.0627,
    width: 0.8781,
    height: 0.8781,
    transform: "translate(3.8529 10.2957) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 14.4926,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.6086 10.8874) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "14.904 1.685 15.524 2.306 16.145 1.685 15.524 1.064 14.904 1.685"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 15.676,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.111 12.0617) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 16.2672,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.8659 12.6526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 16.8596,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6209 13.2454) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 17.4494,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3757 13.8353) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 18.0421,
    y: 4.2029,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.115 14.4011) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 18.633,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8862 15.0187) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 19.2243,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6337 15.5951) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 12.1285,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.7577 8.8738) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 12.7191,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5049 9.4574) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 13.3104,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.2551 10.0429) rotate(-45.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 13.9025,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.0101 10.6355) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 14.4924,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.7643 11.2247) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 15.0859,
    y: 2.4283,
    width: 0.877,
    height: 0.877,
    transform: "translate(2.5134 11.8076) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 15.676,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.2741 12.4083) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 16.2668,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0294 12.9991) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 16.8596,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.7846 13.5918) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 17.4494,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5395 14.1817) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 18.0421,
    y: 5.3845,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2808 14.7459) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 10.9457,
    y: -0.5282,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.4133 8.0394) rotate(-45.1108)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: 11.5358,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(3.1558 8.6179) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 12.1283,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9148 9.2142) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 12.719,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.6627 9.7976) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 13.3102,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4121 10.3803) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 13.9029,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1735 10.9808) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 14.4924,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.9274 11.5714) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "14.904 4.05 15.524 4.671 16.145 4.05 15.524 3.429 14.904 4.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 15.676,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4379 12.7547) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 16.2668,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.1931 13.3455) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 16.8596,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9491 13.9379) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.7627,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(3.0622 7.1983) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 10.354,
    y: 0.0632,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(2.8086 7.781) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 10.9455,
    y: 0.6536,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.5706 8.3808) rotate(-45.0692)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 11.5356,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.3143 8.9585) rotate(-44.9862)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 12.1281,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.0719 9.5529) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 12.7193,
    y: 2.428,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.8262 10.143) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 13.3102,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5758 10.7264) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 13.9025,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3369 11.3273) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 14.4924,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0912 11.9178) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "14.904 5.233 15.524 5.854 16.145 5.233 15.524 4.611 14.904 5.233"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 15.676,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6023 13.1008) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 8.5794,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(2.7118 6.3578) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 9.1708,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.4646 6.9474) rotate(-45.0421)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.7626,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(2.2205 7.54) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 10.3538,
    y: 1.2459,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.9677 8.1221) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 10.9453,
    y: 1.8362,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(1.728 8.7205) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 11.5359,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.4781 9.3037) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 12.1281,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.2349 9.8996) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 12.719,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9897 10.4894) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 13.3102,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7401 11.0721) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 13.9025,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.5007 11.6737) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 14.4924,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2557 12.2639) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 7.3971,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.3667 5.523) rotate(-45.0872)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 7.9881,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1129 6.1052) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 8.5792,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.871 6.6997) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 9.1707,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.6239 7.2893) rotate(-45.0052)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 9.7624,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.3789 7.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 10.3542,
    y: 2.4284,
    width: 0.8768,
    height: 0.8768,
    transform: "translate(1.1317 8.4673) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 10.9453,
    y: 3.0198,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.8908 9.0675) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 11.5356,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6418 9.6499) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 12.1281,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3987 10.246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 12.719,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1535 10.8357) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 13.3102,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.0948 11.4176) rotate(-44.9579)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 6.214,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.0191 4.6853) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 6.8056,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(1.7705 5.2736) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 7.3969,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5263 5.8659) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 7.988,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2735 6.447) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 8.579,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.0304 7.04) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.171,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7876 7.6349) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 9.7624,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.542 8.2267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 10.3538,
    y: 3.6111,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.2954 8.8135) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 10.9453,
    y: 4.2024,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(0.0542 9.4142) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 11.5356,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1942 9.996) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 12.1281,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4368 10.592) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 5.0315,
    y: -0.5279,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(1.6697 3.8461) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 5.6224,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.4202 4.4326) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 6.2138,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.1792 5.0288) rotate(-45.0468)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 6.8054,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.9309 5.6166) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 7.3967,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.686 6.2072) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 7.9883,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.4379 6.792) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 8.579,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.1938 7.3864) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 9.1706,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.049 7.9815) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 9.7624,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.2942 8.5731) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 10.3538,
    y: 4.7937,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5404 9.1595) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 10.9453,
    y: 5.384,
    width: 0.8785,
    height: 0.8785,
    transform: "translate(-0.7816 9.7606) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 3.8484,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(1.3226 3.0089) rotate(-45.0693)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 4.4398,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0762 3.5993) rotate(-45.0369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 5.0313,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.8308 4.1898) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 5.6223,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5818 4.7754) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 6.2136,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.3396 5.3708) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 6.8057,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.0947 5.9623) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 7.3967,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1509 6.5539) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 7.988,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.398 7.1378) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 8.579,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.6421 7.7324) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 9.1706,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8853 8.3278) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 9.7624,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1297 8.9191) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 2.666,
    y: -0.5279,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.9759 2.1724) rotate(-45.0872)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 3.2571,
    y: 0.0629,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7275 2.7602) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 3.8483,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.4842 3.3534) rotate(-45.0277)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 4.4397,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.2377 3.9433) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 5.0312,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.0078 4.5322) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 5.6226,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.2536 5.1205) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 6.2136,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4974 5.7175) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 6.8054,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7419 6.3088) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 7.3967,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9871 6.9003) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 7.988,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.2336 7.4835) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 8.579,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.4773 8.0782) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 1.4829,
    y: -0.528,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6282 1.3347) rotate(-45.0884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 2.0741,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3823 1.9256) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 2.6658,
    y: 0.6538,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.1378 2.5177) rotate(-45.0456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 3.257,
    y: 1.2457,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.1098 3.1041) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 3.8481,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.3538 3.6965) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 4.44,
    y: 2.428,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-0.5983 4.2891) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 5.0312,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.8444 4.8785) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 5.6223,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.0896 5.4664) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 6.2136,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.3336 6.0639) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 6.8054,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.5781 6.6552) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 7.3967,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.8226 7.2463) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 0.3005,
    y: -0.5279,
    width: 0.8772,
    height: 0.8772,
    transform: "translate(0.2803 0.497) rotate(-45.0647)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 0.891,
    y: 0.0628,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0352 1.0884) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 1.4828,
    y: 0.6537,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.2093 1.6806) rotate(-45.0467)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 2.0739,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.4551 2.2707) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 2.6657,
    y: 1.8365,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6997 2.8618) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 3.2573,
    y: 2.4281,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-0.9451 3.4494) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 3.8481,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.1905 4.0429) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 4.4397,
    y: 3.6107,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.4348 4.6355) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 5.0312,
    y: 4.2028,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.6803 5.2246) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 5.6223,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.9251 5.8121) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 6.2136,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1691 6.41) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: -0.8827,
    y: -0.5281,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0673 -0.3406) rotate(-45.0878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: -0.2911,
    y: 0.0628,
    width: 0.8779,
    height: 0.8779,
    transform: "translate(-0.3117 0.2518) rotate(-45.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 0.3003,
    y: 0.6539,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-0.5562 0.8432) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 0.8908,
    y: 1.2455,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.8017 1.4341) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 1.4826,
    y: 1.8364,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.0462 2.0254) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 2.0743,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2911 2.6167) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 2.6657,
    y: 3.0201,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.5366 3.2084) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 3.257,
    y: 3.6109,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.781 3.7952) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 3.8481,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.0264 4.389) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 4.4397,
    y: 4.7933,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.2709 4.9819) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 5.0312,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5154 5.5703) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -0.8829,
    y: 0.6536,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.9035 0.0065) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: -0.2913,
    y: 1.2456,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.148 0.598) rotate(-45.004)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 0.3002,
    y: 1.8366,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.3921 1.1882) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 0.8912,
    y: 2.428,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6376 1.7801) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 1.4826,
    y: 3.02,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8831 2.372) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 2.0739,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.1276 2.9632) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 2.6657,
    y: 4.2027,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.3728 3.5548) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 3.257,
    y: 4.7935,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.6165 4.1409) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 3.8481,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8617 4.7348) rotate(-44.9815)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -0.8831,
    y: 1.8363,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.739 0.3526) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: -0.2909,
    y: 2.4281,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.9838 0.9441) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 0.3002,
    y: 3.0202,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.2287 1.5346) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 0.8908,
    y: 3.6107,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.4742 2.1267) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1.4826,
    y: 4.2026,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.7193 2.7184) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 2.0739,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.9639 3.3096) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 2.6657,
    y: 5.3843,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.2083 3.9009) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -0.8831,
    y: 3.0199,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.576 0.6993) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: -0.2913,
    y: 3.6108,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.8204 1.2907) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 0.3002,
    y: 4.2028,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.0646 1.8806) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 0.8908,
    y: 4.7933,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.3104 2.473) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1.4826,
    y: 5.3842,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.5549 3.0645) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -0.8831,
    y: 4.2025,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-3.4122 1.0456) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: -0.2913,
    y: 4.7934,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.6566 1.637) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 0.3002,
    y: 5.3844,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.8998 2.2264) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: -0.8831,
    y: 5.3841,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-4.2477 1.3917) rotate(-45)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: -0.0002,
    y: -0.0292,
    width: 19.2178,
    height: 5.5723
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrown);
export default __webpack_public_path__ + "static/media/brown.1be13fd6346a2c90c4260d6a21f36d5a.svg";
export { ForwardRef as ReactComponent };